import { render, staticRenderFns } from "./AdminArchives.vue?vue&type=template&id=c4031820"
import script from "./AdminArchives.vue?vue&type=script&lang=js"
export * from "./AdminArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports